export const wmDE = {
  'skitouring': 'Skibergsteigen',
  'horse': 'Zu Pferde',
  'walking': 'Wandern',
  'running': 'Laufen',
  'cycling': 'Radfahren',
  'poi_type': 'Interessante Orte',
  'where': 'Orte',
  'lang': 'Sprache',
  'langPlaceholder': 'Auswählen',
  'from': 'Start',
  'to': 'Ziel',
  'ascent': 'Anstieg +',
  'descent': 'Abstieg -',
  'distance': 'Entfernung',
  'da te': 'von dir',
  'ele_from': 'Start-Höhe',
  'ele_max': 'Max-Höhe',
  'ele_min': 'Min-Höhe',
  'ele_to': 'Ziel-Höhe',
  'difficulty': 'Schwierigkeit',
  'duration_forward': 'Hinweg-Dauer',
  'duration_backward': 'Rückweg-Dauer',
  'Filtri': 'Filter',
  'Cerca': 'Suche',
  'tracce': 'Strecken',
  'hiking': 'Wandern',
  'Escursionismo': 'Wandern',
  'escursionismo': 'Wandern',
  'i miei percorsi': 'Strecke zeichnen',
  'metri': 'Meter',
  'Vedi su OpenStreetMap': 'Auf OpenStreetMap ansehen',
  'Descrizione Audio': 'Audiobeschreibung',
  'il tuo browser non supporta gli elementi audio':
    'Ihr Browser unterstützt keine Audiowiedergabe.',
  'stampa': 'Drucken',
  'Difficoltà': 'Schwierigkeit',
  'Scala di difficoltà CAI': 'CAI-Schwierigkeitsgrad',
  'Questo percorso non è accessibile': 'Diese Strecke ist nicht zugänglich',
  'Descrizione': 'Beschreibung',
  'Punto di partenza': 'Startpunkt',
  'Punto di arrivo': 'Zielpunkt',
  'Dettagli tecnici': 'Technische Details',
  'Attività': 'Aktivitäten',
  'Come arrivare': 'Anreise',
  'Bici muscolari': 'Muskelräder',
  'Bici elettriche': 'Elektroräder',
  'Mezzi pubblici': 'Öffentliche Verkehrsmittel',
  'Auto Propria': 'Eigenes Auto',
  'Punti di interesse': 'POI',
  'Punto di interesse': 'POI',
  'Collegamenti esterni': 'Externe Links',
  'Downloads': 'Downloads',
  'edit geohub': 'Geohub bearbeiten',
  'NCC': 'NCC',
  'Filtri attivi': 'Aktive Filter',
  'Reset filtri': 'Filter zurücksetzen',
  'Torna alla home': 'Zurück zur Startseite',
  'Risultati': 'Ergebnisse',
  'Caricamento in corso.': 'Wird geladen.',
  'Spiacenti non ci sono risultati con questi criteri di ricerca.':
    'Leider gibt es keine Ergebnisse mit diesen Suchkriterien',
  'Bentornato!': 'Willkommen zurück!',
  'Accedi con le tue credenziali per continuare.':
    'Melden Sie sich mit Ihren Zugangsdaten an, um fortzufahren.',
  'E-mail': 'E-mail',
  "L'e-mail è obbligatoria": 'E-Mail ist erforderlich',
  "Hai inserito un'e-mail non valida": 'Sie haben eine ungültige E-Mail eingegeben',
  'Password': 'Passwort',
  'La password è obbligatoria': 'Passwort erforderlich ist',
  'Accedi': 'Login',
  'Hai dimenticato la password?': 'Sie haben Ihr Passwort vergessen?',
  'Accedi e scarica i tuoi percorsi preferiti':
    'Greifen Sie auf Ihre Lieblingsrouten zu und laden Sie sie herunter',
  'Puoi anche condividerli con i tuoi compagni di viaggio':
    'Sie können sie auch mit Ihren Reisebegleitern teilen',
  'Registrati': 'Melden Sie sich an',
  'Tracce scaricate': 'Heruntergeladene Titel',
  'Utilizzo dati': 'Datennutzung',
  'Registrazioni': 'Aufzeichnungen',
  'Photos': 'Photos',
  'Waypoint': 'Waypoint',
  'Nome': 'Name',
  'inserisci il tuo nome': 'Geben Sie Ihren Namen ein',
  "E' necessario inserire un nome": 'Es muss ein Name eingegeben werden',
  'inserisci il tuo cognome': 'Geben Sie Ihren Nachnamen ein',
  "E' necessario inserire un cognome": 'Es muss ein Nachname eingegeben werden',
  'Email': 'Email',
  "E' necessario inserire una email": 'Es ist notwendig, eine E-Mail einzugeben',
  "L'email inserita non è un'email valida": 'Die E-Mail ist ungültig',
  'Codice Fiscale': 'Abgabenordnung',
  'Perché ti chiediamo il CF?': 'Warum fragen wir Sie nach der Abgabenordnung?',
  'Il codice fiscale inserito non è valido': 'Der Steuercode ist ungültig',
  'inserisci password': 'Passwort eingeben',
  "E' necessario inserire la password": 'Es muss ein Passwort eingegeben werden',
  'Conferma password': 'Passwort bestätigen',
  'Ripeti password': 'Wiederholen Sie das Passwort',
  "E' necessario confermare la password": 'Eine Passwortbestätigung ist erforderlich',
  'La conferma non corrisponde con la password inserita sopra':
    'Die Bestätigung stimmt nicht mit dem oben eingegebenen Passwort überein',
  'Cliccando su "Registrati" accetti la nostra':
    'Mit dem Klick auf "Registrieren" akzeptieren Sie unsere',
  'e i': 'e i',
  'Termini e condizioni': 'Geschäftsbedingungen',
  "Errore durante la registrazione dell'utente": 'Fehler bei der Benutzerregistrierung',
  'Registrazione in corso': 'Registrierung läuft',
  'Perchè ti chiediamo il Codice Fiscale?': 'Warum fragen wir Sie nach der Abgabenordnung?',
  'Se sei Socia/o CAI inserisci il tuo CF al momento della registrazione. Per te il download delle tappe del Sentiero Italia CAI sarà automaticamente gratuito!':
    'Wenn Sie CAI-Mitglied sind, geben Sie bei der Registrierung Ihre CF ein. Für Sie ist der Download der Etappen des Sentiero Italia CAI automatisch kostenlos!',
  "Origine dell'immagine": 'Bildquelle',
  'Annulla': 'Stornieren',
  'Dalla libreria': 'Aus der Bibliothek',
  'Scatta una foto': 'Ein Foto machen',
  'Carica File': 'Datei hochladen',
  'Trascina qui il tuo file o clicca per selezionare':
    'Ziehen Sie hier Ihre Datei oder klicken Sie, um zu wählen',
  'Accetta i seguenti formati': 'Akzeptiert die folgenden Formate',
  'Tipo di file non supportato': 'Typ des Dateis nicht unterstützt',
  'Il file non contiene una geometria valida': 'Der Datei enthält keine gültige Geometrie',
  'Errore durante la lettura del file, riprova':
    'Fehler beim Lesen des Dateis, versuchen Sie es erneut',
  'Si è verificato un errore durante il salvataggio della traccia. Riprova':
    'Es ist ein Fehler beim Speichern der Strecke aufgetreten. Versuchen Sie es erneut',
  'La traccia è stata salvata correttamente': 'Die Strecke wurde erfolgreich gespeichert',
  'Scarica il tracciato GPX': 'GPX-Track herunterladen',
  'Scarica il tracciato KML': 'KML-Track herunterladen',
  'Scarica il tracciato GEOJSON': 'GEOJSON-Track herunterladen',
  'Link utili': 'Nützliche Links',
  'apri pdf': 'PDF öffnen',
  'pendenza': 'Steigung',
  'Galleria': 'Galerie',
  'resetta la memoria': 'Speicher zurücksetzen',
  'rimani acceso': 'Immer verbunden',
  'forza il dispositivo a non spegnersi': 'Gerät ausschalten verhindern',
  'PAGINE': 'SEITEN',
  'I tuoi dati': 'Ihre Daten',
  'pages.profile.projectlink': 'Projekt',
  'pages.profile.disclaimerlink': 'Haftungsausschluss',
  'pages.profile.creditslink': 'Credits',
  'pages.profile.privacylink': 'Datenschutz',
  'pages.profile.title': 'Profil',
  'MEMORIA': 'SPEICHER',
  'la distanza espressa in metri che indica la cadenza di rilevamento posizione, più il distance filter è minore piu il consumo della batteria sarà maggiore.':
    'Distanz in Metern, die die Abstände zwischen den Messungen angibt. Je kleiner der Abstand, desto höher ist der Stromverbrauch.',
  "Per registrare tracce e poi correttamente, abilita l'autorizzazione alla posizione nelle impostazioni":
    'Um gültige Routen und Interessantenpunkte zu erfassen, aktivieren Sie die Standortberechtigung in den Einstellungen.',
  'I miei percorsi': 'Meine Strecken',
  'Sentieri': 'Wanderwege',
  'Sentiero': 'Wanderweg',
  'layers': 'Layers',
  '<span class="green">Livello 1: tratti non interessati dall\'alta quota (quota minore di {{orange}} metri)</span>':
    '<span class="green">Stufe 1: Abschnitte nicht von großer Höhe betroffen (Höhe unter {{orange}} Metern)</span>',
  '<span class="orange">Livello 2: tratti parzialmente in alta quota (quota compresa tra {{orange}} metri e {{red}} metri)</span>':
    '<span class="orange">Stufe 2: Abschnitte teilweise in großer Höhe (Höhe zwischen {{orange}} und {{red}} Metern)</span>',
  '<span class="red">Livello 3: in alta quota (quota superiore {{red}} metri)</span>':
    '<span class="red">Stufe 3: in großer Höhe (Höhe über {{red}} Metern)</span>',
  'Un utente è già stato registrato con questa email.':
    'Ein Benutzer ist bereits mit dieser E-Mail registriert.',
  "L'email inserita non è corretta. Per favore, riprova.":
    'Die eingegebene E-Mail ist nicht korrekt. Bitte versuchen Sie es erneut.',
  'La password inserita non è corretta. Per favore, riprova.':
    'Das eingegebene Passwort ist nicht korrekt. Bitte versuchen Sie es erneut.',
  'Errore': 'Fehler',
  'Tempo': 'Zeit',
  'Velocità media': 'Durchschnittsgeschwindigkeit',
  'Velocità massima': 'Maximale Geschwindigkeit',
  'Tipologia di form': 'Formularart',
  'Seleziona il tipo di form': 'Formularart auswählen',
  'File selezionato': 'Ausgewählte Datei',
  'Carica': 'Hochladen',
  'Aggiornamento effettuato con successo': 'Aktualisierung erfolgreich durchgeführt',
  'Ops!': 'Ups!',
  'Non è stato possibile aggiornare, riprova più tardi':
    'Aktualisierung nicht möglich, versuchen Sie es später erneut',
  'Eliminazione effettuata con successo': 'Löschung erfolgreich durchgeführt',
  'Sicuro di voler eliminare questo POI? La rimozione è irreversibile.':
    'Sind Sie sicher, dass Sie diesen POI löschen möchten? Die Löschung ist irreversibel.',
  'Sicuro di voler eliminare questa traccia? La rimozione è irreversibile.':
    'Sind Sie sicher, dass Sie diese Strecke löschen möchten? Die Löschung ist irreversibel.',
  'Login effettuato con successo': 'Login erfolgreich',
  'Logout effettuato con successo': 'Logout erfolgreich',
  'Ottieni indicazioni': 'Indikationen erhalten',
  'Mostra altro': 'Mehr anzeigen',
  'Distanza da te': 'Entfernung von Ihnen',
  'Mostra meno': 'Weniger anzeigen',
  'Mostra tutti': 'Alle anzeigen',
  'Lunghezza': 'Länge',
  'Orario previsto': 'Voraussichtlicher Zeitpunkt',
  'Dimensione': 'Größe',
  'questo campo è obbligatorio': 'Dieses Feld ist erforderlich',
  'Quota': 'Höhe',
  'I miei downloads': 'Meine Downloads',
  'foto dalla galleria': 'foto aus der Galerie',
  'Dimensione massime: 3 photo': 'Maximale Größe: 3 Fotos',
  'Aggiungi': 'Hinzufügen',
  'Foto': 'Foto',
  '(max 3 photo)': '(max 3 Fotos)',
  'art-and-culture': 'Kunst und Kultur',
  'tourism': 'Tourismus',
  'e-bike': 'E-Bike',
  'touring-bike': 'Touring-Bike',
  'train-trekking': 'Zug-Trekking',
  'road-bike': 'Straßenrad',
  'ciaspole': 'Schneeschuhe',
  'adventure': 'Abenteuer',
  'swimming-snorkeling': 'Schwimmen-Schnorcheln',
  'birdwatching': 'Vogelbeobachtung',
  'oeno-gastronomy': 'Wein-Gastronomie',
  'nordic-walking': 'Nordic Walking',
  'joelette': 'joelette',
  'mtb': 'MTB',
  'mountain-bike': 'Mountainbike',
  'Ottieni le indicazioni su Google Maps': 'Indikationen auf Google Maps erhalten',
  'Per il punto di partenza': 'Für den Startpunkt',
  "Per il punto più vicino in linea d'aria": 'Für den nächsten Punkt in Luftlinie',
  'Tipo di form': 'Formularart',
  'massimo': 'maximal',
  'foto': 'Fotos',
  'Carica foto dalla libreria': 'Fotos aus der Bibliothek laden',
  'Luogo': 'Ort',
  'Luoghi': 'Orte',
  'Percorso': 'Pfad',
  'Percorsi': 'Pfade',
  'salva': 'speichern',
  'Il salvataggio è stato completato': 'Das Speichern ist erfolgreich',
  'Stai modificando le coordinate del POI, vuoi continuare?':
    'Sie ändern die Koordinaten des POI, möchten Sie fortfahren?',
  'No': 'Nein',
  'Sì': 'Ja',
  'Attenzione': 'Achtung',
  'Disegna': 'Zeichnen',
  'Esci': 'Aus',
  'Hai salvato correttamente il tuo waypoint. Puoi visualizzarlo accedendo al tuo profilo.':
    'Sie haben Ihren Wegpunkt erfolgreich gespeichert. Sie können ihn anzeigen, indem Sie sich in Ihr Profil einloggen.',
  'Cliccando su "Registrati" accetti la nostra privacy e i termini e condizioni':
    'Mit dem Klick auf "Registrieren" akzeptieren Sie unsere Datenschutzrichtlinie und unsere Geschäftsbedingungen',
  'culture-history': 'Kultur und Geschichte',
  'environmental-education': 'Umweltbildung',
  'eating-sleeping': 'Essen und Schlafen',
  'by-car': 'Auto',
  'Eliminazione': 'Löschen',
  'Elimina': 'Löschen',
  'Sei sicuro di voler eliminare questi dati?':
    'Sind Sie sicher, dass Sie diese Daten löschen möchten?',
  'Modifica consenso dati': 'Dateneinwilligung ändern',
  'Dati non sincronizzati': 'Nicht synchronisierte Daten',
  'Lingua': 'Sprache',
  'Azione irreversibile': 'Unwiderrufliche Aktion',
  'Vuoi veramente eliminare il tuo account? È obbligatorio scrivere "delete account" per procedere.':
    'Möchten Sie Ihr Konto wirklich löschen? Es ist erforderlich, "delete account" zu schreiben, um fortzufahren.',
  'Digita "delete account"': 'Schreiben Sie "delete account"',
  'Conferma': 'Bestätigen',
  'La conferma non corrisponde. Digita "delete account" per procedere.':
    'Die Bestätigung stimmt nicht mit dem oben eingegebenen Passwort überein. Schreiben Sie "delete account" um fortzufahren.',
  'Elimina account': 'Löschen Sie das Konto',
  'Aggiornamento disponibile': 'Update verfügbar',
  "È disponibile una nuova versione dell'app. Aggiorna per ottenere le ultime funzionalità e miglioramenti.":
    'Eine neue Version der App ist verfügbar. Aktualisieren Sie jetzt, um die neuesten Funktionen und Verbesserungen zu erhalten.',
  'Aggiorna ora': 'Jetzt aktualisieren',
  'Più tardi': 'Später',
  'Versione disponibile': 'Verfügbare Version',
  'È stata rilevata una registrazione interrotta. Vuoi riprenderla?':
    'Eine unterbrochene Aufzeichnung wurde erkannt. Möchten Sie sie fortsetzen?',
  'Riprendi': 'Fortsetzen',
  'Info': 'Info',
  'Chiudi': 'Schließen',
  'Store non disponibile': 'Store nicht verfügbar',
  "Non è stato possibile aprire direttamente lo store. Prova ad aprire manualmente la pagina dell'app nello store.":
    'Es war nicht möglich, den Store direkt zu öffnen. Versuchen Sie, die App-Seite im Store manuell zu öffnen.',
  'Aggiornamento obbligatorio': 'Pflichtupdate',
  "Per continuare a utilizzare l'app è necessario installare l'ultima versione disponibile.":
    'Um die App weiter nutzen zu können, müssen Sie die neueste verfügbare Version installieren.',
  "È disponibile una nuova versione dell'app.": 'Eine neue Version der App ist verfügbar.',
  "Dove": "Ort",
  "Regione": "Region",
  "Provincia": "Provinz",
  "Comune": "Gemeinde",
  'layer': 'Layer',
  'Nessun risultato': 'Keine Ergebnisse',
  'Condividi': 'Teilen',
  'Condivisione in corso': 'Wird geteilt',
  'Condivisione non riuscita': 'Teilen fehlgeschlagen',
  'Riprova': 'Erneut versuchen',
  'Aggiungi ai preferiti': 'Zu Favoriten hinzufügen',
  'Rimuovi dai preferiti': 'Aus Favoriten entfernen',
  'Preferito': 'Favorit',
  'Non preferito': 'Kein Favorit',
  'Impossibile aggiornare i preferiti, riprova': 'Favoriten konnten nicht aktualisiert werden, versuche es erneut',
  'Modifica profilo': 'Profil bearbeiten',
  'Cambia foto': 'Foto ändern',
  'Il nome è obbligatorio': 'Der Name ist erforderlich',
  'Il nome non può superare i 255 caratteri': 'Der Name darf 255 Zeichen nicht überschreiten',
  'Cognome': 'Nachname',
  'Il cognome non può superare i 255 caratteri': 'Der Nachname darf 255 Zeichen nicht überschreiten',
  'Salva': 'Speichern',
};
